import React from 'react'
import Close from 'react-icons/lib/md/close'
import PropTypes from 'prop-types'

function CloseIcon(props) {
  return props.show ? <Close {...props} /> : null
}

CloseIcon.propTypes = {
  show: PropTypes.bool
}

export default CloseIcon
